module.exports = __webpack_public_path__ + "img/dynamic-10.9c3bb633.png";